import axiosClient from './axiosClient';

const SELECTED_MENU_STORAGE_KEY = 'selected_menu_id';

const getSelectedMenuId = () => {
  return localStorage.getItem(SELECTED_MENU_STORAGE_KEY) || '';
};

export const menuTemplatesApi = {
  getTemplates(params = {}) {
    return axiosClient.get('/menu-templates', {
      params,
    });
  },

  getTemplate(templateId) {
    return axiosClient.get(
      `/menu-templates/${templateId}`,
    );
  },

  getMenuPreview(establishmentId, menuId = null) {
    const selectedMenuId =
      menuId ||
      getSelectedMenuId();

    return axiosClient.get(
      `/establishments/${establishmentId}/menu-preview`,
      {
        params: selectedMenuId
          ? {
              menu_id: selectedMenuId,
            }
          : {},
      },
    );
  },

  selectTemplate(
    establishmentId,
    payload,
    menuId = null,
  ) {
    const selectedMenuId =
      menuId ||
      payload?.menu_id ||
      getSelectedMenuId();

    return axiosClient.patch(
      `/establishments/${establishmentId}/menu-template`,
      {
        ...payload,

        ...(selectedMenuId
          ? {
              menu_id: selectedMenuId,
            }
          : {}),
      },
    );
  },

  getMenuShare(establishmentId, menuId = null) {
    const selectedMenuId =
      menuId ||
      getSelectedMenuId();

    return axiosClient.get(
      `/establishments/${establishmentId}/menu-share`,
      {
        params: selectedMenuId
          ? {
              menu_id: selectedMenuId,
            }
          : {},
      },
    );
  },
};

export default menuTemplatesApi;